import LoginPage from "pages/loginPage";
import ResetPasswordForm from "pages/loginPage/components/resetPasswordForm";
import PasswordRestEmailSent from "pages/loginPage/passwordResetEmailSent";
import Assessment from "pages/assessment";
import ApplicationGuide from "pages/customForms/userGuidance/applicationGuidance";
import ProjectOverview from "pages/customForms/projectOverview";
import InstructionalCoachingGuide from "pages/customForms/instructionalCoachingGuide/instructionalCoachingGuide";
import DeliberatePracticeGuide from "pages/customForms/deliberatePracticeGuide/deliberatePracticeGuide";
import ProfilePage from "pages/profilePage";
import OrgAdmin from "pages/admin/OrgAdmin/orgAdmin";
import LocationAdmin from "pages/admin/LocationAdmin/locationAdmin";
import DivisionAdmin from "pages/admin/DivisionAdmin/divisionAdmin";
import LevelAdmin from "pages/admin/LevelAdmin/levelAdmin";
import UserAdmin from "pages/admin/UserAdmin/userAdmin";
import Principles from "pages/admin/Principles";
import Questions from "pages/admin/Questions";
import Assessments from "pages/assessments";
import AssesseeTable from "pages/coaching";
import CoachingFeed from "pages/coaching/coachingFeed";

export const publicRoutes = [
  { path: "/", element: <LoginPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/password-reset-sent", element: <PasswordRestEmailSent /> },
  { path: "/reset-password/:token", element: <ResetPasswordForm /> },
];

export const layoutRoutes = [
  { path: "tl-principles-graph", element: <Assessment /> },
  { path: "tl-foci-graph", element: <Assessment /> },
  { path: "/home", element: <ApplicationGuide />, requiresAuth: true },
  {
    path: "/project-overview",
    element: <ProjectOverview />,
    requiresAuth: true,
  },
  {
    path: "/instructional-coaching-guide",
    element: <InstructionalCoachingGuide />,
    requiresAuth: true,
  },
  {
    path: "/deliberate-practice-guide",
    element: <DeliberatePracticeGuide />,
    requiresAuth: true,
  },
  { path: "/profile", element: <ProfilePage />, requiresAuth: true },
  {
    path: "organisation",
    element: <OrgAdmin />,
    requiresAuth: true,
    canAccess: ({ showOrg }) => showOrg,
  },
  {
    path: "schools",
    element: <LocationAdmin />,
    requiresAuth: true,
    canAccess: ({ showOrg }) => showOrg,
  },
  {
    path: "subjects",
    element: <DivisionAdmin />,
    requiresAuth: true,
    canAccess: ({ showDivision, showSeniorLeader, isAcademyImprovementLead }) =>
      showDivision || showSeniorLeader || isAcademyImprovementLead,
  },
  {
    path: "years",
    element: <LevelAdmin />,
    requiresAuth: true,
    canAccess: ({ showLevel, showSeniorLeader, isAcademyImprovementLead }) =>
      showLevel || showSeniorLeader || isAcademyImprovementLead,
  },
  {
    path: "users",
    element: <UserAdmin />,
    requiresAuth: true,
    canAccess: ({ isAnyAdmin, showSeniorLeader, isAcademyImprovementLead }) =>
      isAnyAdmin || showSeniorLeader || isAcademyImprovementLead,
  },
  {
    path: "tl-principles",
    element: <Principles />,
    requiresAuth: true,
    canAccess: ({ isAnyAdmin, showSeniorLeader, isAcademyImprovementLead }) =>
      isAnyAdmin || showSeniorLeader || isAcademyImprovementLead,
  },
  {
    path: "tl-foci",
    element: <Questions />,
    requiresAuth: true,
    canAccess: ({ isAnyAdmin, showSeniorLeader, isAcademyImprovementLead }) =>
      isAnyAdmin || showSeniorLeader || isAcademyImprovementLead,
  },
  {
    path: "lesson-visits",
    element: <Assessments />,
    requiresAuth: true,
    canAccess: ({ showSeniorLeader, showDivision, isAcademyImprovementLead }) =>
      showSeniorLeader || showDivision || isAcademyImprovementLead,
  },
  {
    path: "coaching",
    element: <AssesseeTable />,
    requiresAuth: true,
    canAccess: ({ showSeniorLeader, showDivision, isAcademyImprovementLead }) =>
      showSeniorLeader || showDivision || isAcademyImprovementLead,
  },
  {
    path: "coaching-feed",
    element: <CoachingFeed />,
    requiresAuth: true,
    canAccess: ({ showSeniorLeader, showDivision, isAcademyImprovementLead }) =>
      showSeniorLeader || showDivision || isAcademyImprovementLead,
  },
  {
    path: "coaching-feed/:userId",
    element: <CoachingFeed />,
    requiresAuth: true,
    canAccess: ({ showSeniorLeader, showDivision, isAcademyImprovementLead }) =>
      showSeniorLeader || showDivision || isAcademyImprovementLead,
  },
];
